<template>
  <div class="visitor">
    <div class="visitor_content">
      <div class="return_content" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>

      <el-form
        :model="form"
        ref="hook-form"
        label-width="100px"
        class="form_con"
        :style="{
          width: isLandscape ? 70 + '%' : 100 + '%'
        }"
      >
        <el-row style="flex-wrap: wrap" type="flex">
          <el-col :span="colParams">
            <el-form-item label="来访类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in options.typeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="colParams">
            <el-form-item label="访问园区" prop="park">
              <el-select v-model="form.park" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in options.parkList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="colParams">
            <el-form-item label="被访人姓名" prop="phone">
              <el-input v-model="form.name" />
            </el-form-item>
          </el-col>
          <el-col :span="colParams">
            <el-form-item label="被访人电话" prop="phone">
              <el-input v-model="form.phone" />
            </el-form-item>
          </el-col>
          <el-col :span="colParams">
            <el-form-item label="被访人部门" prop="dept">
              <el-input v-model="form.dept" />
            </el-form-item>
          </el-col>
          <el-col :span="colParams">
            <el-form-item label="同行人员" prop="peopleNum" class="add-button">
              <el-input v-model="form.peopleNum" />
              <el-button class="confirm_btm" @click="PeoAdd">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="车牌号码" prop="car" class="add-button">
              <el-input v-model="form.carInfo" />
              <el-button
                v-if="form.type != 10"
                class="confirm_btm"
                @click="visibleCar = true"
                >添加</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="colParams">
            <el-form-item label="访客电话" prop="visitorPhone">
              <el-input v-model="form.visitorPhone" />
            </el-form-item>
          </el-col>
          <el-col :span="colParams">
            <el-form-item label="访客姓名" prop="visitorName">
              <el-input v-model="form.visitorName" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="访客公司" prop="visitorDept">
              <el-input v-model="form.visitorDept" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="来访时间" prop="visitorTime">
              <el-date-picker
                v-model="form.visitorTime"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="timeChange"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="footer_btn">
              <el-button class="cancel_btn" @click="handleSubmitPeoCon"
                >取 消</el-button
              >
              <el-button
                class="confirm_btm"
                :loading="btnLoading"
                @click="handleSubmit"
              >
                确 定
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog :visible.sync="visiblePeo" width="600px" top="25vh">
      <div slot="title">
        <span class="peo-title">同行人名单</span>
      </div>
      <el-table :data="tablePeo" class="table-peo">
        <el-table-column label="序号" type="index" width="100">
        </el-table-column>
        <el-table-column label="同行人姓名" prop="name" />
        <el-table-column label="同行人手机号" prop="phone" />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visiblePeo = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitPeo"> 确 定 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :destroy-on-close="true"
      :visible.sync="visibleCar"
      width="600px"
    >
      <div slot="title">
        <span class="peo-title">车牌号选择</span>
      </div>
      <div>
        <car @carNum="carNum" />
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="visibleCar = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitCar"> 确 定 </el-button>
      </div> -->
    </el-dialog>

    <el-dialog
      :destroy-on-close="true"
      :visible.sync="visiblePeoAdd"
      width="600px"
      top="20vh"
    >
      <div slot="title">
        <span class="peo-title">添加同行人</span>
      </div>
      <el-form :model="form" ref="hook-form" label-width="40px">
        <el-form-item label="姓名" prop="phone">
          <el-input v-model="baseinfo.name" placeholder="请输入同行人姓名" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input
            placeholder="请输入11位手机号"
            v-model="baseinfo.phone"
            @blur="blur"
            type="text"
            maxlength="11"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <el-button class="addPeople" @click="addPeople" type="primary"
        >添加</el-button
      >
      <el-table :data="tablePeo" class="table-peo">
        <el-table-column label="序号" type="index" width="100">
        </el-table-column>
        <el-table-column label="同行人姓名" prop="name" />
        <el-table-column label="同行人手机号" prop="phone" />
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <span @click="emitPeople(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visiblePeoAdd = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitPeoAdd">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <audio src="@/assets/autio/success(1).wav" class="success"></audio>
    <audio src="@/assets/autio/fail(1).wav" class="fail"></audio>
    <!-- 二维码不在本园区 -->
    <audio src="@/assets/autio/text2audio.mp3" class="audio"></audio>
  </div>
</template>

<script>
import apis from "@/apis";
import car from "./car.vue";

export default {
  name: "visitor",
  components: {
    car
  },
  data() {
    return {
      baseinfo: {
        name: "",
        phone: "",
        id: ""
      },
      visible: false,
      visiblePeo: false,
      visibleCar: false,
      visiblePeoAdd: false,
      tableLoading: false,
      btnLoading: false,
      form: {
        visitorTime: []
      },
      pageData: {
        page: 1,
        pageSize: 10
      },
      value: "",
      options: {
        parkList: [],
        typeList: [],
        statusList: [
          { id: 10, label: "未确认" },
          { id: 20, label: "已确认" },
          { id: 30, label: "已签到" },
          { id: 90, label: "已拒绝" },
          { id: 99, label: "已取消" }
        ]
      },
      model: {},
      total: 0,
      boardData: {
        left: [],
        right: []
      },
      tableList: [],
      tablePeo: [],
      selection: [],
      input: "",
      state: false,
      flag: false,
      windowHeight: 300,
      isLandscape: false,
      colParams: 12
    };
  },
  watch: {
    model: function () {
      this.pageData.page = 1;
    },
    value: function () {
      this.pageData.page = 1;
    }
  },
  beforeDestroy() {
    window.removeEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
  },
  methods: {
    // 判断横竖屏
    handleOrientationChange() {
      this.isLandscape =
        window.orientation === 90 || window.orientation === -90;
      this.colParams = this.isLandscape ? 12 : 24;
    },
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 440;
      });
    },
    // 返回
    goBack() {
      this.$router.back(-1);
      this.form = {};
    },
    // 手机号验证
    blur() {
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.baseinfo.phone)) {
        this.$notify({
          type: "warning",
          message: "请正确输入手机格式",
          duration: 2000
        });
        this.baseinfo.phone = "";
      }
    },
    // 提交表单
    handleSubmit() {
      let arr = [];
      let str = this.form.carInfo ? this.form.carInfo.split(",") : [];
      str &&
        str.forEach(item => {
          arr.push({ carNr: item });
        });
      this.form.cars = arr;
      if (this.form.type == 10 && this.form.cars.length > 1) {
        return this.$notify({
          type: "warning",
          message: "只能添加一辆车牌号码",
          duration: 2000
        });
      }
      this.btnLoading = true;
      this.form.peers = this.tablePeo;
      const time = JSON.parse(JSON.stringify(this.form.visitorTime));
      this.form.visitorTime = time[0];
      this.form.visitorTimeEnd = time[1];
      apis
        .visitorLogAddOrUpdate(this.form)
        .then(() => {
          this.$router.back(-1);
          this.form = {};
        })
        .finally(() => (this.btnLoading = false));
    },
    //关闭同行人名单
    handleSubmitPeo() {
      this.visiblePeo = false;
    },
    //确认添加同行人
    handleSubmitPeoAdd() {
      this.visiblePeoAdd = false;
      this.form.peopleNum = this.tablePeo.length;
    },
    //取消
    handleSubmitPeoCon() {
      this.$router.back(-1);
      this.form = {};
    },
    // 添加同行人
    addPeople() {
      this.baseinfo.id = Math.ceil(Math.random() * 1000);
      const arr = JSON.parse(JSON.stringify(this.baseinfo));
      if (this.baseinfo.name !== "" && this.baseinfo.phone !== "") {
        this.tablePeo.push(arr);
      } else {
        this.$notify({
          type: "warning",
          message: "名字或手机号不能为空",
          duration: 2000
        });
      }
    },
    //编辑同行人
    emitPeople(row) {
      console.log(row);
      const index = this.tablePeo.findIndex(item => {
        return item.id === row.id;
      });
      this.tablePeo.splice(index, 1);
    },
    // 添加同行人员
    PeoAdd() {
      this.visiblePeoAdd = true;
      this.baseinfo.name = "";
      this.baseinfo.phone = "";
      if (!this.flag) {
        apis.peersQueryPeers({ id: this.form.id }).then(data => {
          this.tablePeo = data.data;
          this.flag = true;
        });
      }
    },
    // 车牌号选择
    carNum(value) {
      if (value.length !== 0) {
        const arr = value.join(",").replace(/,/g, "");
        let oa = this.form.carInfo ? this.form.carInfo : "";
        if (oa !== "") {
          oa += "," + arr;
        } else {
          oa = arr;
        }
        this.form.carInfo = oa;
      }

      this.visibleCar = false;
    },
    // 获取园区列表和访客类型列表
    getOptions() {
      const options = this.options;
      apis.parkQueryAll({ type: 3 }).then(({ data }) => {
        options.parkList = data;
      });

      apis.visitorTypeQueryList().then(({ data }) => {
        options.typeList = data;
      });
    },
    // 选择时间
    timeChange(v) {
      let val = ["", ""];
      if (v) {
        val = v;
      }
      this.form.visitorTime = val;
    }
  },
  mounted() {
    if (localStorage.getItem("visitorInfo")) {
      this.form = JSON.parse(localStorage.getItem("visitorInfo"));
    }
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    window.addEventListener("orientationchange", this.handleOrientationChange);
    // 初始加载时检测一次方向
    this.handleOrientationChange();
    this.getOptions();
  }
};
</script>

<style lang="scss" scoped>
.visitor {
  height: calc(100vh - 34px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
}

.visitor_content {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #e2e6f5;
  // margin-bottom: 8px;
  height: 99%;
  // height: calc(100% - 34px);
  .return_content {
    margin-bottom: 22px;
    font-size: 14px;
    color: #18191e;
  }
  .form_con {
    // width: 70%;
    .footer_btn {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
      .confirm_btm {
        border: 1px solid #388654;
        background-color: #388654;
        color: #fff;
        border-radius: 0;
      }
      .cancel_btn {
        border: 1px solid #388654;
        color: #388654;
        border-radius: 0;
      }
    }
  }
}
.handle {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  // height: 30px;
  button {
    width: 60px;
    margin-bottom: 10px;
  }
  .input_content {
    margin-bottom: 10px;
  }
  div {
    display: flex;
    align-items: center;
    // width: 568px;
    width: 100%;
    max-width: 190px;

    span {
      width: 40px;
      margin-left: 15px;
      color: #606266;
      font-size: 10px;
    }
  }
}
.table-container {
  margin-bottom: 10px;
}
.unconfirmed {
  color: #d02727;
}
.affirm {
  color: #018755;
}
.handle-edit {
  cursor: pointer;
}
.pager {
  display: flex;
  justify-content: flex-end;
}
.success,
.fail {
  display: none;
}

.peo-title {
  padding-left: 40%;
  font-size: 16px;
}

.addPeople {
  // position: absolute;
  // top: 45px;
  // right: 20px;
  float: right;
}

.add-button {
  ::v-deep .el-input {
    float: left;
    // width: 280px;
  }
  .confirm_btm {
    border: 1px solid #388654;
    background-color: #388654;
    color: #fff;
  }
  ::v-deep .el-button {
    float: right;
    margin-left: 10px;
  }
  ::v-deep {
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }
}

.table-peo {
  ::v-deep .cell {
    font-size: 11px !important;
    line-height: 30px !important;
  }
}

::v-deep {
  .cell {
    font-size: 10px;
  }
  // .el-checkbox__inner {
  //   width: 16px;
  //   height: 16px;
  // }
  // .el-checkbox__inner::after {
  //   width: 5px;
  //   height: 9px;
  //   left: 5px;
  //   top: 1px;
  // }
}
</style>
